
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
// import Overview from './components/Overview';
import DataInputs from './components/DataInputs';
import CrossSellOpportunity from './components/CrossSellOpportunity';
import './App.css'; // Import the CSS file

function App() {
  return (
    <Router>
      <div className="sidebar">
        <ul>
          {/* <li><Link to="/">Overview</Link></li> */}
          <li><Link to="/"> Overview </Link></li>
          <li><Link to="/cross-sell-opportunity">Cross Sell Opportunity</Link></li>
        </ul>
      </div>
      <div className="content">
        <Routes>
          {/* <Route path="/" element={<Overview />} /> */}
          <Route path="/" element={<DataInputs />} />
          <Route path="/cross-sell-opportunity" element={<CrossSellOpportunity />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
